const translate = {
    en: {
        products: 'Products',
        contactUs: 'Contact us',
        landingHeader1: 'Fast AC Services --When You',
        landingHeader2: ' Need It Most.',
        landingHeader3: ' Same-day service. Certified technicians. 100% satisfaction guarantee.',
        advantagesHeader: 'Our Advantages',
        advantagesTitle1: 'Partners to',
        advantagesTitle2: 'Trust',
        advantagesNumbers1: 'Years of providing Home Electronics to homes',
        advantagesNumbers2: 'Satisfied Customers across the region',
        advantagesNumbers3: 'Average Service Rating',
        servicesHeader: 'Our Services',
        servicesTitle1: 'Everything your Home Could Ever Need.',
        servicesTitle2: 'From Blenders, Fans to Air Conditioners, we have it all.',
        servicesTitle3: 'Explore our wide range of products and services Designed to get your comfort back.',
        serviceTitle1: 'Blenders',
        serviceTitle2: 'Dispensers',
        serviceTitle3: 'Air Conditioners',
        serviceText1: 'We offer a wide range of blenders, from classic to modern, to meet your culinary needs.',
        serviceText2: 'We have a wide selection of dispensers, from classic to modern, to meet your needs.',
        serviceText3: 'We have a wide selection of air conditioners, from classic to modern, to meet your needs.',
        howHeader: 'How It Works',
        howTitle1: 'From Call to Deliver in 5 Steps',
        howTitle2: "Getting your products delivered is a breeze with our hassle-free delivery process. Simply place your order, and we'll take care of the rest.",
        howStepTitle1: 'Browse Products',
        howStepTitle2: 'Select & Order',
        howStepTitle3: 'Delivery',
        howStepTitle4: 'Installation',
        howStepTitle5: 'Support',
        howStepHeader1: 'Explore Our Range',
        howStepHeader2: 'Choose Your Favorites',
        howStepHeader3: 'Fast & Reliable',
        howStepHeader4: 'Professional Setup',
        howStepHeader5: 'Ongoing Assistance',
        howStepText1: 'Discover a wide selection of home electronics tailored to your needs.',
        howStepText2: 'Pick your preferred products and place your order with ease.',
        howStepText3: 'Get your products delivered quickly to your doorstep.',
        howStepText4: 'Our experts ensure seamless installation for optimal performance.',
        howStepText5: 'Enjoy continuous support for any questions or issues.',
        latestHeader: 'Our Latest Products',
        latestTitle1: 'Check Out latest added Products.',
        latestTitle2: 'We have chosen the best for you as if we are chosing it for ourself.',
        viewAll: 'View All',
        faqHeader: 'FAQ',
        faqTitle1: 'Frequently Asked Questions',
        faqTitle2: "Answering your questions is our mission - just don't hesitate to reach out with us.",
        faqQuestion1: 'How do I place an order?',
        faqQuestion2: 'What are your delivery options?',
        faqQuestion3: 'How long does delivery take?',
        faqQuestion4: 'What is your return policy?',
        faqQuestion5: 'Do you offer installation services?',
        faqAnswer1: 'You can place an order directly on our website by selecting products, adding them to your cart, and proceeding to checkout. We also accept orders via phone or in-store.',
        faqAnswer2: 'We offer standard home delivery, express shipping, and in-store pickup. Delivery fees vary based on location and order size.',
        faqAnswer3: 'Standard delivery typically takes 3-7 business days, depending on your location. Express options can deliver within 1-2 days.',
        faqAnswer4: 'We accept returns within 30 days of purchase for most items, provided they are in original condition with packaging. Some appliances may have specific return guidelines.',
        faqAnswer5: 'Yes, we provide professional installation for select appliances like air conditioners, refrigerators, and washing machines at an additional cost.',
        QuickLinks: 'Quick Links',
        Social: 'Social Media',
        Facebook: 'Facebook',
        Instagram: 'Instagram',
        Youtube: 'Youtube',
        Twitter: 'Twitter',
        BookCall: 'Book a Call',
        BookText: ' You read so far, might as well need a call',
        Email: 'Email Address',
        Phone: 'Phone Number',
        Copyright: `Copyright © ${new Date().getFullYear()} Home Electronics. All rights reserved.`,
        Privacy: 'Privacy Policy',
        Terms: 'Terms and Conditions',
        // New keys for ProductsPage
        filters: 'Filters',
        minPrice: 'Min Price',
        maxPrice: 'Max Price',
        searchPlaceholder: 'Search...',
        sortLatest: 'Latest',
        sortPriceLowToHigh: 'Price: Low to High',
        sortPriceHighToLow: 'Price: High to Low',
        LastUpdated: 'Last Updated',
        Specifications: 'Specifications',
        egp: 'EGP',
        details: 'Details',
        viewProduct: 'View Product',
    },
    ar: {
        products: 'المنتجات',
        contactUs: 'تواصل معنا',
        landingHeader1: 'توفير الأجهزة الكهربائية -- في',
        landingHeader2: 'الأوقات الأصعب.',
        landingHeader3: 'خدمة سريعة. مهندسين مصنفين. ضمان سلامة 100%.',
        advantagesHeader: 'مميزاتنا',
        advantagesTitle1: 'شركـــاء',
        advantagesTitle2: 'نثق بهم',
        advantagesNumbers1: 'سنوات من توفير الاجهزة الكهربائية في المنازل',
        advantagesNumbers2: 'عملائنا الاوفياء في جمهورية مصر العربية',
        advantagesNumbers3: 'متوسط تقييم خدماتنا',
        servicesHeader: 'خدماتنا',
        servicesTitle1: 'كل ما يمكن ان يحتاج البيت له.',
        servicesTitle2: 'من الخلاطات, المراوح الي المكيفات , نحن نوفر كل شيء.',
        servicesTitle3: 'تصفح تشكيلتنا الواسعة من المنتجات التي صممت خصيصا لتعيد الراحة الي منزلك.',
        serviceTitle1: 'خلاطات',
        serviceTitle2: 'مراوح',
        serviceTitle3: 'مكيفات',
        serviceText1: 'نقدم مجموعة كبيرة من الخلاطات من القديم للحديثة لتوافق احتياجاتك.',
        serviceText2: 'نقدم مجموعة كبيرة من المراوح من القديم للحديثة لتوافق احتياجاتك.',
        serviceText3: 'نقدم مجموعة كبيرة من المكيفات من القديم للحديثة لتوافق احتياجاتك.',
        howHeader: 'آلية العمل',
        howTitle1: 'من الاتصال إلى التوصيل في 5 خطوات',
        howTitle2: "توصيل منتجاتك أصبح في غاية السهولة بفضل عملية التوصيل السهلة لدينا. ما عليك سوى تقديم طلبك، وسنتولى الباقي.",
        howStepTitle1: 'تصفح المنتجات',
        howStepTitle2: 'اختر واطلب',
        howStepTitle3: 'توصيل',
        howStepTitle4: 'تثبيت',
        howStepTitle5: 'دعم',
        howStepHeader1: 'استكشف مجموعتنا',
        howStepHeader2: 'اختر المفضلة لديك',
        howStepHeader3: 'سريع وموثوق',
        howStepHeader4: 'الإعداد الاحترافي',
        howStepHeader5: 'المساعدة المستمرة',
        howStepText1: 'اكتشف تشكيلة واسعة من الأجهزة الإلكترونية المنزلية المصممة خصيصًا لتلبية احتياجاتك.',
        howStepText2: 'اختر المنتجات المفضلة لديك واطلبها بكل سهولة.',
        howStepText3: 'احصل على منتجاتك بسرعة وتسليمها إلى باب منزلك.',
        howStepText4: 'يضمن خبرائنا التثبيت السلس للحصول على الأداء الأمثل.',
        howStepText5: 'استمتع بالدعم المستمر لأي أسئلة أو مشكلات.',
        latestHeader: 'أحدث المنتجات',
        latestTitle1: 'تعرف على أحدث المنتجات المضافة.',
        latestTitle2: 'لقد اخترنا لك الأفضل وكأننا نختاره لأنفسنا.',
        viewAll: 'عرض الكل',
        faqHeader: 'التعليمات',
        faqTitle1: 'الأسئلة الشائعة',
        faqTitle2: 'الإجابة على أسئلتك هي مهمتنا - فقط لا تتردد في التواصل معنا.',
        faqQuestion1: 'كيف يمكنني طلب منتج؟',
        faqQuestion2: 'ما هي خيارات التوصيل المتاحة؟',
        faqQuestion3: 'كم من الوقت تستغرق عملية التوصيل؟',
        faqQuestion4: 'ما هي سياسة الإرجاع الخاصة بكم؟',
        faqQuestion5: 'هل تقدمون خدمات التركيب؟',
        faqAnswer1: 'يمكنك طلب منتج مباشرة من خلال موقعنا عن طريق اختيار المنتجات وإضافتها إلى سلة التسوق الخاصة بك ومتابعة عملية الدفع. نقبل أيضًا الطلبات عبر الهاتف أو في المتجر.',
        faqAnswer2: 'نقدم خيارات توصيل قياسية إلى المنازل، وشحن سريع، واستلام من المتجر. تختلف رسوم التوصيل حسب الموقع وحجم الطلب.',
        faqAnswer3: 'عادةً ما تستغرق عملية التوصيل القياسية من 3 إلى 7 أيام عمل، اعتمادًا على موقعك. يمكن أن توفر الخيارات السريعة التوصيل في غضون يومين إلى يومين.',
        faqAnswer4: 'نقبل الإرجاع خلال 30 يومًا من الشراء لمعظم العناصر، بشرط أن تكون في حالة أصلية مع التعبئة. قد تحتوي بعض الأجهزة على إرشادات إرجاع محددة.',
        faqAnswer5: 'نعم، نقدم خدمات التركيب الاحترافية لبعض الأجهزة مثل مكيفات الهواء والثلاجات وغسالات الملابس بتكلفة إضافية.',
        QuickLinks: 'روابط سريعة',
        Social: 'وسائل التواصل الاجتماعي',
        Facebook: 'فيسبوك',
        Instagram: 'إنستجرام',
        Youtube: 'يوتيوب',
        Twitter: 'تويتر',
        BookCall: 'احجز مكالمة',
        BookText: ' لقد قرأت حتى الآن، قد تحتاج إلى مكالمة',
        Email: 'عنوان البريد الإلكتروني',
        Phone: 'رقم الهاتف',
        Copyright: `حقوق النشر © ${new Date().getFullYear()} الأجهزة المنزلية. جميع الحقوق محفوظة.`,
        Privacy: 'سياسة الخصوصية',
        Terms: 'الشروط والأحكام',
        // New keys for ProductsPage
        filters: 'الفلاتر',
        minPrice: 'الحد الأدنى للسعر',
        maxPrice: 'الحد الأقصى للسعر',
        searchPlaceholder: 'بحث...',
        sortLatest: 'الأحدث',
        sortPriceLowToHigh: 'السعر: من الأقل إلى الأعلى',
        sortPriceHighToLow: 'السعر: من الأعلى إلى الأقل',
        LastUpdated: 'آخر تحديث',
        Specifications: 'المواصفات',
        egp: 'جنيه مصري',
        details: 'تفاصيل',
        viewProduct: 'عرض المنتج',
    }
}

export default translate